import { StepType } from "@redotech/redo-flows-core-common/common";
import {
  ErrorHandlingStrategy,
  RuleActionType,
  RuleTriggerType,
} from "@redotech/redo-model/advanced-flow/rules/types";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { DefaultRule } from "../types";

/**
 * Default rule: Generate Conversation Insights
 *
 * Signals the generateConversationInsightsWorkflow Temporal workflow on every
 * message (customer or merchant). The workflow debounces for 2 hours — each
 * signal resets the timer, so insights are generated 2 hours after the last
 * message in the conversation.
 *
 * hidden: true — backend-only system rule; merchants do not need to see or
 * configure it.
 */
export const generateConversationInsightsRule = {
  id: "default-generate-conversation-insights",
  name: "Generate Conversation Insights",
  description:
    "Signals AI conversation insights generation on every message. Insights are generated after a 2-hour debounce.",
  hidden: true,
  triggerType: RuleTriggerType.MESSAGE_RECEIVED,

  defaultConfig: {
    defaultRuleId: "default-generate-conversation-insights",
    enabled: true,
    // Hidden rule — large sortIndex keeps it out of the way if ever surfaced.
    sortIndex: 10_000,
    configurations: {},
  },

  template: {
    name: "Generate Conversation Insights",
    description:
      "Signals AI conversation insights generation on every message. Insights are generated after a 2-hour debounce.",
    enabled: true,
    schemaType: SchemaType.RULES_V3,
    steps: [
      {
        type: StepType.TRIGGER,
        id: "trigger",
        schemaType: SchemaType.RULES_V3,
        category: "Rules",
        key: RuleTriggerType.MESSAGE_RECEIVED,
        nextId: "actions",
      },
      {
        type: StepType.RULE_ACTIONS,
        id: "actions",
        actions: [
          { actionType: RuleActionType.GENERATE_CONVERSATION_INSIGHTS },
        ],
        errorHandlingStrategy: ErrorHandlingStrategy.CONTINUE_ON_ERROR,
      },
    ],
  },
} as const satisfies DefaultRule;
